import { styled } from '@mui/material';

interface Props {
  name: string;
  size?: 'medium' | 'large';
  onClick?: () => void;
}

const getInitials = (name: string) => {
  const names = name?.split(' ');
  if (names?.length) {
    const initials = names.length > 1 ? `${names[0][0]}${names[names.length - 1][0]}` : names[0][0];
    if (!initials) return '';
    return initials.toUpperCase();
  }
};

const Wrapper = styled('div')<{ size: 'medium' | 'large' }>`
  background-color: ${({ theme }) => theme.colors.primary[70]};
  border-radius: 50%;
  width: ${({ size }) => (size === 'medium' ? '24px' : '40px')};
  height: ${({ size }) => (size === 'medium' ? '24px' : '40px')};
  min-width: ${({ size }) => (size === 'medium' ? '24px' : '40px')};
  min-height: ${({ size }) => (size === 'medium' ? '24px' : '40px')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const Letters = styled('p')<{ size: 'medium' | 'large' }>`
  color: ${({ theme }) => theme.colors.primary[0]};
  border-radius: 50%;
  line-height: 27px;
  font-size: ${({ size }) => (size === 'medium' ? '10px' : '18px')};
  font-family: ${({ size }) =>
    size === 'medium' ? 'PPNeueMontreal-Regular' : 'PPNeueMontreal-Medium'};
  font-weight: ${({ size }) => (size === 'medium' ? '400' : '500')};
`;

export const UserAvatar = ({ name, size = 'large', onClick }: Props) => {
  return (
    <Wrapper size={size} onClick={onClick}>
      <Letters size={size}>{getInitials(name)}</Letters>
    </Wrapper>
  );
};
